export const authApiEndpoints = {
    FETCH_USER_DATA: 'auth/user',
    FETCH_ADMIN_USER_DATA: 'manage/auth/user',
    USER_LOGIN: 'auth',
    USER_LOGOUT: 'auth/logout',
    GET_USER_SIGNED_AUTH_URL: 'user/signed/authenticate',
};
